{
  "auth": {
    "logoAlt": "Smart Word Labs",
    "checkEmail": {
      "title": "Check your email",
      "confirmationBody": "We sent a confirmation link to <strong>{{email}}</strong>. Confirm it to activate your account, then sign in.",
      "magicLinkBody": "We sent a one-time sign-in link to <strong>{{email}}</strong>. Open it on this device to sign in.",
      "backToSignIn": "Back to Parent Sign In"
    },
    "heading": {
      "magicMode": "Magic link sign in",
      "signup": "Create your parent account",
      "signin": "Parent Sign In"
    },
    "subheading": {
      "magicMode": "Enter your email and we'll send you a one-time sign-in link.",
      "signup": "Manage your children's lessons, billing and progress in one place.",
      "signin": "Sign in to your parent portal."
    },
    "social": {
      "google": "Continue with Google",
      "apple": "Continue with Apple"
    },
    "or": "or",
    "fields": {
      "email": "Email",
      "password": "Password",
      "fullName": "Full name",
      "country": "Country",
      "phone": "Phone"
    },
    "buttons": {
      "pleaseWait": "Please wait…",
      "sendMagicLink": "Send magic link",
      "createAccount": "Create account",
      "signIn": "Sign in"
    },
    "toggle": {
      "useMagicLink": "Email me a magic link instead",
      "usePassword": "Use email and password instead"
    },
    "footer": {
      "haveAccount": "Already have an account?",
      "signIn": "Sign in",
      "newHere": "New to Smart Word Labs?",
      "bookAssessment": "Book a free assessment"
    },
    "errors": {
      "couldNotSignIn": "Could not sign in",
      "enterEmailFirst": "Enter your email first",
      "somethingWentWrong": "Something went wrong"
    },
    "toasts": {
      "magicLinkSent": "Sign-in link sent — check your email"
    }
  },
  "reviews": {
    "title": "Parent Reviews",
    "description": "Honest feedback from families learning with Smart Word Labs. Share your own experience below — reviews appear here once we've checked them.",
    "starsAriaLabel": "{{rating}} out of 5 stars",
    "starPickerAriaLabel": "Star rating",
    "starAriaLabel": "{{count}} star",
    "starAriaLabel_plural": "{{count}} stars",
    "whatParentsSay": "What parents say",
    "empty": "No published reviews yet — yours could be the first.",
    "form": {
      "title": "Write a review",
      "yourRating": "Your rating",
      "yourName": "Your name",
      "email": "Email (optional, not published)",
      "childAge": "Child's age (optional)",
      "location": "City / country (optional)",
      "yourReview": "Your review",
      "bodyPlaceholder": "What changed for your child? What do you value about the lessons?",
      "website": "Website",
      "submit": "Submit review"
    },
    "sent": {
      "title": "Review received",
      "body": "Thank you for sharing your experience. We publish reviews after a quick check.",
      "writeAnother": "Write another review"
    },
    "errors": {
      "chooseRating": "Please choose a star rating.",
      "tooFast": "That was quick! Please take a moment and try again.",
      "bodyTooShort": "Please write at least a couple of sentences.",
      "checkForm": "Please check the form",
      "saveFailed": "We couldn't save your review. Please try again."
    },
    "toasts": {
      "submitted": "Thank you — your review has been submitted for review."
    }
  }
}
